// Food Production Entry API Service
import { api } from '../middleware/api';

// Define types based on backend models
export interface fp_eproduction {
  fp_id: number;
  fp_company: string;
  fp_no: string;
  fp_date: Date | string;
  fp_kitchen: number;
  fp_outlet: number;
  fp_status: number;
  fp_remarks: string;
  fp_uid: string;
  fp_cdt: Date | string;
  fp_muid: string;
  fp_mdt: Date | string;
  fp_details: fp_eproductiondetails[];
}

export interface fp_eproductiondetails {
  fd_id: number;
  fd_fpid: number;
  fd_srid: number;
  fd_product: number;
  fd_recipe: number;
  fd_planned_qty: number;
  fd_actual_qty: number;
  fd_wastage_qty: number;
  fd_unit_cost: number;
  fd_total_cost: number;
  fd_sale_price: number;
  fd_consumption: fp_econsumption[];
}

export interface fp_econsumption {
  fc_id: number;
  fc_fpid: number;
  fc_fdid: number;
  fc_product: number;
  fc_expected_qty: number;
  fc_actual_qty: number;
  fc_rate: number;
  fc_amount: number;
}

// Define endpoints using injectEndpoints pattern
export const fpeproductionApi = api
  .enhanceEndpoints({ addTagTypes: ['FPEProduction'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFPEProductions: builder.query<fp_eproduction[], string>({
        query: cid => `fpeproduction/${cid}`,
        providesTags: ['FPEProduction'],
      }),
      getFPEProductionById: builder.query<fp_eproduction, string>({
        query: id => `fpeproduction/byid/${id}`,
      }),
      insertFPEProduction: builder.mutation({
        query: production => ({
          url: `fpeproduction/`,
          method: 'POST',
          body: production,
        }),
        invalidatesTags: ['FPEProduction'],
      }),
      updateFPEProduction: builder.mutation({
        query: production => ({
          url: `fpeproduction/`,
          method: 'PUT',
          body: production,
        }),
        invalidatesTags: ['FPEProduction'],
      }),
      updateFPEProductionStatus: builder.mutation({
        query: production => ({
          url: `fpeproduction/status`,
          method: 'PUT',
          body: production,
        }),
        invalidatesTags: ['FPEProduction'],
      }),
      deleteFPEProduction: builder.mutation({
        query: production => ({
          url: `fpeproduction/${production.fp_id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['FPEProduction'],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in functional components
export const {
  useGetFPEProductionsQuery,
  useGetFPEProductionByIdQuery,
  useInsertFPEProductionMutation,
  useUpdateFPEProductionMutation,
  useUpdateFPEProductionStatusMutation,
  useDeleteFPEProductionMutation,
} = fpeproductionApi;
